import type { LoanEvent } from '@/types';
import { EVENT_TYPE_ICONS, summarizeEvent, eventDateLabel } from '../../events/eventDisplay';
import { EVENT_TYPE_LABELS } from '@/types';

interface TimelineItemProps {
  event: LoanEvent;
  onClick: () => void;
}

export function TimelineItem({ event, onClick }: TimelineItemProps) {
  const isSuperseded = !!event.supersededAt;
  return (
    <div
      className={`timeline-item${isSuperseded ? ' timeline-item-superseded' : ''}`}
      onClick={onClick}
      role="button"
      tabIndex={0}
    >
      <div className="timeline-icon">{EVENT_TYPE_ICONS[event.type]}</div>
      <div className="timeline-item-body">
        <div className="timeline-item-title">{summarizeEvent(event)}</div>
        <div className="timeline-item-meta">
          {EVENT_TYPE_LABELS[event.type]} · {eventDateLabel(event)}
          {isSuperseded && ' · Superseded'}
        </div>
        {event.note && <div className="timeline-item-meta">"{event.note}"</div>}
      </div>
    </div>
  );
}
